import { AVAILABLE_CURRENCIES_LIST } from 'src/common/config'

const currencyGlyphMap = {
  BTC: '₿',
  GEL: '₾',
  TJS: 'c.',
  DOGE: 'Ð',
  UZS: 'V',
  KGS: 'K',
  BYN: 'B',
}

export const OLYMP_FONT_CURRENCY_MAP = {
  GEL: '₾',
  BTC: '₿',
  TJS: 'c.',
  KGS: '℀',
  UZS: '⚟',
  BDT: '৳',
  BYN: '▤',
  DOGE: '⚞',
}

export function toFixed(num, precision) {
  return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision)
}

export function numberFilter(
  value,
  currency,
  minDigits = 0,
  maxDigits = 0,
  locale = 'ru-RU',
  notation = 'standard',
  isOlympFont = false,
) {
  const newValue = Number(toFixed(value || 0, maxDigits))

  if ((currency === 'INR' || currency === 'BDT') && locale === 'ru-RU') {
    locale = 'hi-IN'
  }

  if ((currency === 'ARS' || currency === 'COP') && locale === 'ru-RU') {
    locale = 'es-CO'
  }

  const glyphCurrency = isOlympFont ? getOlympFontCurrencySymbol(currency) : getGlyphCurrency(currency)

  const formatNumber = (options) => new Intl.NumberFormat(locale, options).format(newValue)

  const baseOptions = {
    minimumFractionDigits: Math.min(minDigits, maxDigits),
    maximumFractionDigits: Math.max(minDigits, maxDigits),
    notation,
  }

  if (glyphCurrency) {
    const number = formatNumber(baseOptions)
    const currencyString = isOlympFont ? glyphCurrency : `<span class='currencies-font'>${glyphCurrency}</span>`

    if (currency === 'BDT' || currency === 'INR') {
      return `${currencyString}${number}`
    }

    // eslint-disable-next-line no-irregular-whitespace
    return `${number} ${currencyString}`
  }

  if (!currency) {
    return formatNumber(baseOptions)
  }

  if (['ARS', 'COP'].includes(currency)) {
    return `$${formatNumber(baseOptions)}`.replace(/\s+/g, '')
  }

  try {
    return formatNumber({
      ...baseOptions,
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
    })
  } catch {
    return `${formatNumber(baseOptions)} ${currency || ''}`.trim()
  }
}

export function formatMoneyInText(text, options = {}) {
  const isOlympFont = options?.isOlympFont ?? false
  const currenciesList = options?.currencies ?? AVAILABLE_CURRENCIES_LIST
  const currencyPart = currenciesList.join('|')
  const re = new RegExp(`(-?\\d+(?:\\.\\d+)?) (${currencyPart})`, 'g')

  return text?.replace(re, (full, value, currency) => {
    const formattedValue = numberFilter(Number(value), currency, 0, 2, 'ru-RU', 'standard', isOlympFont)

    return /^0\d{2}$/.test(value) ? formattedValue.replace(/\d+/, value) : formattedValue
  })
}

export function getCurrencySymbol(currency, locale = 'ru-RU', currencyDisplay = '') {
  try {
    const options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }

    if (currency) {
      options.currency = currency
      options.style = 'currency'

      if (currencyDisplay) {
        options.currencyDisplay = currencyDisplay
      }
    }

    return (0).toLocaleString(locale, options).replace(/\d/g, '').trim()
  } catch {
    return ''
  }
}

export function getGlyphCurrency(currency) {
  return currencyGlyphMap[currency] || null
}

export function getOlympFontCurrencySymbol(currencyCode) {
  return OLYMP_FONT_CURRENCY_MAP[currencyCode] || ''
}
